import { useState, useEffect } from "react";
import { fetchNiches, fetchKeywordHistory, fetchNicheJobs, saveNicheSuggestion } from "../../core/api/nichesApi";
import { fetchPostcodeDistricts } from "../../core/api/locationsApi";
import { useAccount } from "../../core/hooks/useAccount";
import { summariseKeywordHistory } from "../../core/data/scanPlan";

const HISTORY_DELAY_MS = 300;

// Every niche with its sub-groups, loaded once.
export function useNiches() {
  const [niches, setNiches] = useState([]);
  useEffect(() => {
    let cancelled = false;
    fetchNiches().then(list => { if (!cancelled) setNiches(list); });
    return () => { cancelled = true; };
  }, []);
  return niches;
}

// Every UK postcode district (for the radius picks), loaded once.
export function usePostcodeDistricts() {
  const [districts, setDistricts] = useState([]);
  useEffect(() => {
    let cancelled = false;
    fetchPostcodeDistricts().then(list => { if (!cancelled) setDistricts(list); });
    return () => { cancelled = true; };
  }, []);
  return districts;
}

// Your history for each keyword (data dots) and your past scans in the
// chosen niche ("Use your set"), plus saving a niche suggestion.
export default function useSearchData({ userId, nicheId, standardForms }) {
  const [history, setHistory] = useState({});
  const [nicheJobs, setNicheJobs] = useState({ count: 0, latestKeywords: [] });

  // Re-checked shortly after the keywords change.
  const formsKey = standardForms.join("|");
  useEffect(() => {
    let cancelled = false;
    const timer = setTimeout(async () => {
      const forms = formsKey ? formsKey.split("|") : [];
      const rows = await fetchKeywordHistory({ standardForms: forms, userId });
      if (!cancelled) setHistory(summariseKeywordHistory(rows));
    }, HISTORY_DELAY_MS);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [formsKey, userId]);

  useEffect(() => {
    let cancelled = false;
    fetchNicheJobs({ nicheId, userId }).then(result => { if (!cancelled) setNicheJobs(result); });
    return () => { cancelled = true; };
  }, [nicheId, userId]);

  const account = useAccount();
  const saveSuggestion = async (text) => {
    if (!account) return null;
    return saveNicheSuggestion({ agencyId: account.agencyId, userId, text });
  };

  return { history, nicheJobs, saveSuggestion };
}
